import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { theme } from '../../../../theme/theme'
import { OnClickButton } from '../../../buttons/onclick/OnClickButton'
import { isPrintSupportedBrowser } from '../../../../utils/browserPrintSupport'
import { ExportWarningModal } from './ExportWarningModal'

type Props = {
  hasInsufficientData: boolean
  onExport: () => void
}

export const ExportReportButton = ({ hasInsufficientData, onExport }: Props) => {
  const { t } = useTranslation()
  const [showWarnings, setShowWarnings] = useState(false)

  const warnings = [
    ...(isPrintSupportedBrowser(window.navigator) ? [] : [t('admin.statistics.exportUnsupportedText')]),
    ...(hasInsufficientData ? [t('admin.statistics.exportInsufficientDataText')] : []),
  ]

  const handleExport = () => {
    if (warnings.length === 0) {
      onExport()
      return
    }
    setShowWarnings(true)
  }

  const handleExportAnyway = () => {
    setShowWarnings(false)
    onExport()
  }

  return (
    <>
      <OnClickButton
        text={t('admin.statistics.exportReport')}
        buttonColor={theme.color.orange}
        onClick={handleExport}
      />
      {showWarnings && (
        <ExportWarningModal
          warnings={warnings}
          onClose={() => setShowWarnings(false)}
          onExportAnyway={handleExportAnyway}
        />
      )}
    </>
  )
}
